import LazyLoaderErrorBoundary from '@components/Errors/LazyLoaderErrorBoundary';
export default async function Loadable() {
    const { Submission } = await import('./index');
    return {
        Component: Submission,
        ErrorBoundary: LazyLoaderErrorBoundary,
    };
}
